import { createFileRoute } from "@tanstack/react-router"

import { PageNotFound } from "@/components/feedback/page-not-found"
import { notFoundHead, respondNotFound } from "@/lib/not-found"

/**
 * `app/global-not-found.tsx`: every URL no route matches. A real 404, with
 * the not-found title and noindex, and none of the site layout's tags.
 */
export const Route = createFileRoute("/$")({
  loader: () => {
    respondNotFound()
  },
  head: () => notFoundHead({ layout: false }),
  component: PageNotFound,
})
